import { useEffect, useState } from "react"
import { useEditor, Vec } from "tldraw"

export function Coordinates() {
  const editor = useEditor()

  const [coordinates, setCoordinates] = useState<Vec | null>(null)

  const page = editor.getCurrentPage()

  useEffect(() => {
    let ticking = false

    const handlePointerMove = (e: PointerEvent) => {
      const screenPoint = { x: e.clientX, y: e.clientY }

      if (!ticking) {
        requestAnimationFrame(() => {
          setCoordinates(editor.screenToPage(screenPoint))
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener("pointermove", handlePointerMove)
    return () => {
      window.removeEventListener("pointermove", handlePointerMove)
    }
  }, [editor])
  if (!coordinates) return null
  return (
    <div style={{ position: "absolute", bottom: 0, left: 0, zIndex: 9999 }}>
      {Math.round(coordinates.x)}, {Math.round(coordinates.y)}
    </div>
  )
}
